import { setDataForApi } from "utils/api";
import { FormSchemaProduct } from "./types";

const parseDataForApi = (data: FormSchemaProduct) => {
  const _data = { ...data };
  setDataForApi(_data);
  return _data;
};

export default parseDataForApi;
